import { useSyncExternalStore } from 'react';

/**
 * Tracks a CSS media query. Used where a breakpoint swaps a whole layout (table
 * vs list, inline vs stacked nav) rather than just restyling it, so only one
 * version is in the DOM. Without matchMedia (jsdom) it reports `fallback`.
 */
export function useMediaQuery(query: string, fallback = true): boolean {
  return useSyncExternalStore(
    (onChange) => {
      if (typeof window === 'undefined' || !window.matchMedia) return () => {};
      const mq = window.matchMedia(query);
      mq.addEventListener?.('change', onChange);
      return () => mq.removeEventListener?.('change', onChange);
    },
    () => (typeof window !== 'undefined' && window.matchMedia ? window.matchMedia(query).matches : fallback),
    () => fallback,
  );
}

/** The layout breakpoints from the design brief. */
export const BP = {
  wordmark: '(min-width: 1100px)',
  membersTable: '(min-width: 1000px)',
  wideNav: '(min-width: 900px)',
  rosterCalendar: '(min-width: 760px)',
  roomy: '(min-width: 640px)',
} as const;
